import { Directive, HostBinding, Input } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";

@Directive({
    selector: `
        [modRelativePosition],[modFixedPosition],[modAbsolutePosition]
    `,
})
export class PositionModifierDirective {
    @Input() @BooleanAttribute() @HostBinding("class.u-position-relative") public modRelativePosition: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-position-fixed") public modFixedPosition: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-position-absolute") public modAbsolutePosition: boolean;
}
